import {
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@sc/ui-components';
import { SnackBarData } from '../../types';

@Component({
  selector: 'sc-snackbar-error',
  styleUrls: ['./snackbar-error.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [IconComponent, TranslateModule],
  template: `
    <div class="notification-color"></div>
    <div class="icon-container">
      <sc-icon name="info" specificName="snackbar_error_icon"></sc-icon>
    </div>
    <section
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="sc-bottom-snackbar-title"
      aria-describedby="sc-bottom-snackbar-body"
    >
      <div class="top">
        <div class="title hide-focus-outline">
          <p
            role="heading"
            aria-level="1"
            tabindex="-1"
            id="sc-bottom-snackbar-title"
            class="sc-design-title-h2"
          >
            {{ data.title }}
          </p>
        </div>

        <button type="button" (click)="onCloseClick()">
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeErrorSnackbar'
              | translate
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>
      <div class="msg">
        <p id="sc-bottom-snackbar-body">{{ data.message }}</p>
      </div>
    </section>
  `,
})
export class SnackbarErrorComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData) {}

  @HostListener('document:keydown.escape')
  onCloseClick(): void {
    this.data.currentSnackBar.dismiss();
  }
}
